import { Component } from '@angular/core';
import { Route, Router } from '@angular/router';
import { MovieService } from '../movie.service';
@Component({
  selector: 'app-movies-section',
  templateUrl: './movies-section.component.html',
  styleUrls: ['./movies-section.component.scss']
})
export class MoviesSectionComponent {
  click = true ;
  findData :any;
  getData :any[] =[];
 trendingClick = false ;
 tamilClick = false;
 hollywoodClick = false;
 bollywoodClick = false;
  Trending =[
    {
      id :1,
      imgSrc :"../../assets/related-section-image-sardar.webp",
      title :"Sardar",
      description :``
    },
    {
      id :2,
      imgSrc :"../../assets/download.jpg",
      title :"Avatar2",
      description :""
    },
    {
      id:3,
      imgSrc :"../../assets/Ponniyin_Selvan_I.jpg",
      title :"Ponniyin Selvan part-01",
      description :""
    },
    {
      id :4 ,
      imgSrc :"../../assets/Bholaa-306x393.jpg",
      title :"Sita Raman",
      description :""
    }
  ];
  Trending1 =[
    {
      id :1,
      imgSrc :"../../assets/related-section-image-sardar.webp",
      title :"Sardar",
      description :``
    },
    {
      id :2,
      imgSrc :"../../assets/download.jpg",
      title :"Avatar2",
      description :""
    },
    {
      id:3,
      imgSrc :"../../assets/Ponniyin_Selvan_I.jpg",
      title :"Ponniyin Selvan part-01",
      description :""
    },
    {
      id :4 ,
      imgSrc :"../../assets/Bholaa-306x393.jpg",
      title :"Sita Raman",
      description :""
    }
  ];
  Trending2 =[
    {
      id :1,
      imgSrc :"../../assets/related-section-image-sardar.webp",
      title :"Sardar",
      description :``
    },
    {
      id :2,
      imgSrc :"../../assets/download.jpg",
      title :"Avatar2",
      description :""
    },
    {
      id:3,
      imgSrc :"../../assets/Ponniyin_Selvan_I.jpg",
      title :"Ponniyin Selvan part-01",
      description :""
    },
    {
      id :4 ,
      imgSrc :"../../assets/Bholaa-306x393.jpg",
      title :"Sita Raman",
      description :""
    }
  ];
tamilMovies =[
  {
    imgSrc :"../../assets/related-section-image-sardar.webp",
    title :"Sardar",
    description :""
  },
  {
    imgSrc :"../../assets/download.jpg",
    title :"Avatar2",
    description :""
  },
  {
    imgSrc :"../../assets/Ponniyin_Selvan_I.jpg",
    title :"Ponniyin Selvan part-01",
    description :""
  },
  {
    imgSrc :"../../assets/MV5BN2RjZDJhYzUtOTQ5Yy00OWM3LWE5OTctM2Y0YWVmNzAzODllXkEyXkFqcGdeQXVyMTA3MDk2NDg2._V1_.jpg",
    title :"Sita Raman",
    description :""
  },
  
];
hollywood =[
  {
    imgSrc :"../../assets/related-section-image-sardar.webp",
    title :"Sardar",
    description :""
  },
  {
    imgSrc :"../../assets/download.jpg",
    title :"Avatar2",
    description :""
  },
  {
    imgSrc :"../../assets/Ponniyin_Selvan_I.jpg",
    title :"Ponniyin Selvan part-01",
    description :""
  },
  {
    imgSrc :"../../assets/MV5BN2RjZDJhYzUtOTQ5Yy00OWM3LWE5OTctM2Y0YWVmNzAzODllXkEyXkFqcGdeQXVyMTA3MDk2NDg2._V1_.jpg",
    title :"Sita Raman",
    description :""
  },
  
];
bollywood =[
  {
    imgSrc :"../../assets/related-section-image-sardar.webp",
    title :"Sardar",
    description :""
  },
  {
    imgSrc :"../../assets/download.jpg",
    title :"Avatar2",
    description :""
  },
  {
    imgSrc :"../../assets/Ponniyin_Selvan_I.jpg",
    title :"Ponniyin Selvan part-01",
    description :""
  },
  {
    imgSrc :"../../assets/MV5BN2RjZDJhYzUtOTQ5Yy00OWM3LWE5OTctM2Y0YWVmNzAzODllXkEyXkFqcGdeQXVyMTA3MDk2NDg2._V1_.jpg",
    title :"Sita Raman",
    description :""
  },
  
];

constructor(private md :MovieService ,public router :Router) {
let data = JSON.stringify(this.Trending);
if(data){
  let parseData = JSON.parse(data);
  this.Trending.concat(parseData);
}
md.setTrendingData(data)
}

viewTrending(i:any){
  this.click = false;
  this.tamilClick = true;
  this.findData = i;
}
viewTamilMovies(i : any){
  this.click = false;
  this.tamilClick = true;
  this.findData = i;
}
viewhollywoodMovies(i : any){
  this.click = false;
  this.hollywoodClick = true;
  this.findData = i;
}
viewbollywoodMovies(i : any){
  this.click = false;
  this.bollywoodClick = true;
  this.findData = i;
}
goBack(){
 this.click = true;
}
}
